import { formatSeconds } from '@capturi/ui-components'
import { Flex, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { KeyTopicTitle } from 'components/styles/KeyTopicTitle'
import SummaryBox from 'components/SummaryBox'
import { MagicBox, MagicBoxHeader } from 'copilot/components/MagicBox'
import type { FC } from 'react'

type Props = {
  agent: {
    email: string
    name: string
  }
  team?: string
  subject: string
  duration: number
  dateTime: string
  customSummary: string
  conversationUid: string
  keyTopic?: string
  subKeyTopic?: string
  rootCause?: string
}

const formatDate = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}).format
const SingleConversation: FC<Props> = ({
  agent,
  dateTime,
  duration,
  subject,
  customSummary,
  keyTopic,
  subKeyTopic,
  rootCause,
  conversationUid,
}) => {
  const formattedDuration = formatSeconds(duration)
  return (
    <MagicBox>
      <MagicBoxHeader>
        <Flex w="100%" justify="space-between" gap="4" alignItems="center">
          <KeyTopicTitle keyTopic={keyTopic} subKeyTopic={subKeyTopic} />
          <Flex
            flex="0 2 500px"
            justifyContent="flex-end"
            gap="1"
            alignItems="baseline"
            minW="0"
          >
            <Text
              fontSize="xs"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              minW="0"
            >
              {subject}
            </Text>
            <Text fontSize="xs">|</Text>
            <Text
              fontSize="sm"
              fontWeight={500}
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {agent.name}
            </Text>
          </Flex>
        </Flex>
        <Flex
          w="100%"
          justify="space-between"
          textAlign="right"
          alignItems="center"
        >
          <Text color="greys.400" fontSize="sm">
            <Trans>{formattedDuration} minutes</Trans>
          </Text>
          <Text color="greys.400" fontSize="sm">
            {formatDate(new Date(dateTime))}
          </Text>
        </Flex>
      </MagicBoxHeader>
      <SummaryBox
        conversationUid={conversationUid}
        rootCause={rootCause}
        customSummary={customSummary}
      />
    </MagicBox>
  )
}

export default SingleConversation
